import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '../../Button';
import CloseIcon from '../close.svg';

export const ToggleButtonTooltip = ({ open, handleCloseTooltip }) =>
  open && (
    <div className="freelancer-chooser__filters-tooltip">
      <Button
        transparent
        className="freelancer-chooser__filters-tooltip-close"
        onClick={handleCloseTooltip}
      >
        <img alt="close" src={CloseIcon} />
      </Button>
      <div className="freelancer-chooser__filters-tooltip-title">
        Turn on Instant Book
      </div>
      <div className="freelancer-chooser__filters-tooltip-description">
        Automatically book editor without needing their approval.
      </div>
    </div>
  );

ToggleButtonTooltip.propTypes = {
  open: PropTypes.bool,
  handleCloseTooltip: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/components/FreelancerChooser/ToggleButtonTooltip/ToggleButtonTooltip.js